export { default as HomeLogin } from '../modules/Home/views/src/pages/Login.vue'
export { default as HomeChangePassword } from '../modules/Home/views/src/pages/ChangePassword.vue'
export { default as HomeIndex } from '../modules/Home/views/src/pages/Index.vue'
export { default as HomeGestioneSamm } from '../modules/Home/views/src/pages/GestioneSamm.vue'
export { default as HomeGestioneAdmin } from '../modules/Home/views/src/pages/GestioneAdmin.vue'
export { default as HomeReport } from '../modules/Home/views/src/pages/Report.vue'
export { default as HomeSettings } from '../modules/Home/views/src/pages/Settings.vue'
export { default as Error404 } from '../modules/Home/views/src/pages/404.vue'


// WEBPACK FOOTER //
// ./imports/index.js